import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';
import MediaPreview from 'components/MediaPreview';

import { __t, applyTranslations } from 'utils/language';

import './outfit-media-to-view.scss';

applyTranslations(require('./outfit-media-to-view.i18n.json'));

import { PreviewOutfit } from 'types';

type Props = {
  outfit: PreviewOutfit
};

const msgKey = 'outfit_media_to_view';

const OutfitMediaToView = ({
  outfit
}: Props) => {
  const previewWidth = 183;
  const previewHeight = 183;

  return (
    <div key={`outfit-media-attachment-${outfit.id}`}>
      <div className="outfit-media-to-view__container">
        <div
          onContextMenu={(e) => {
            e.preventDefault();
          }}
          onClick={(e) => {
            e.preventDefault();
          }}
          style={{ width: previewWidth, height: previewHeight }}
        >
          <MediaPreview
            className="outfit-media-to-view__media"
            key={`outfit-media-to-view-${outfit.id}`}
            attachment={{
              id: outfit.imageUrl,
              url: outfit.imageUrl
            }}
            width={previewWidth}
            height={previewHeight}
            showPdfFileName={false}
          />
        </div>
        <div className="outfit-media-to-view__outfit-mode">
          <div className="outfit-media-to-view__outfit-info">
            <span>{__t(`${msgKey}.labels.outfit`)}:</span>
            <span>{outfit.name}</span>
            <span>{__t(`${msgKey}.labels.creator`)}:</span>
            <span>{outfit.creatorInstagramHandle || '-'}</span>
          </div>
        </div>
        <div
          className="outfit-media-to-view__outfit-action-container outfit-media-to-view__outfit-action-container--with-button"
        >
          <ActionButton
            width="small"
            height="normal"
            style="normal"
            color="primary"
            link={outfit.wmcShortLinkUrl ?? outfit.outfitPreview}
            newTab
          >
            {__t(`${msgKey}.labels.view_on_zalando`)}
          </ActionButton>
        </div>
      </div>
    </div>
  );
};

export default OutfitMediaToView;
